<template>
  <div class="laypanel" style="margin-left: 40px; margin-right: 40px;">
    <el-tabs :tab-position="gctabpos" v-model="qdinfotab" style="height: 200px;">
      <el-tab-pane label="产品信息管控" name="cpinfogk">
        <el-tabs tab-position="right" value="0">
          <el-tab-pane label="代理授权">
            <div>
              <el-row class="querypanel">
                <el-col :span="8"><div class="queryinput">
                  <el-input v-model="query_goodsinfoname" placeholder="请输入产品名称"></el-input>
                </div></el-col>
                <el-col :span="8"><div class="queryinput">
                  <el-select v-model="goodsinfobrand" filterable placeholder="请选择产品品牌">
                    <el-option
                      v-for="item in goodsinfobrandlist"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </div></el-col>
                <el-col :span="8"><div>
                  <el-select v-model="goodsinfotype" filterable placeholder="请选择产品类别">
                    <el-option
                      v-for="item in goodsinfotypelist"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </div></el-col>
                <el-col :span="24" class="querybtn" style="margin-top: 15px">
                  <div>
                    <el-button @click="querygoodsinfo">查找产品</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-col :span="24">
                  <div class="queryinput">
                  <el-transfer
                    filterable
                    :titles="['产品库', '待授权产品']"
                    v-model="goods_rightdata"
                    :data="goods_leftdata"
                    :props="{
                    key: 'id',
                    label: 'name'
                    }"
                  >
                  </el-transfer>
                </div>
                </el-col>
              </el-row>
              <el-row class="querypanel">
                <el-tabs v-model="qdsqtab" @tab-click="qbsqclick">
                  <el-tab-pane label="渠道授权" name="qdsq">
                    <el-col :span="8">
                      <el-card class="box-card leftpanel">
                        <div slot="header" class="clearfix">
                          <span>传统渠道列表</span>
                        </div>
                        <div>
                          <el-tree
                            class="filter-tree"
                            :data="qddata"
                            :props="qdprops"
                            default-expand-all
                            :expand-on-click-node="false"
                            @node-click="gcqdselect">
                          </el-tree>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :span="16">
                      <el-card class="box-card leftpanel">
                        <div slot="header" class="clearfix">
                          <span>授权客户清单</span>
                          <el-button style="float: right; padding: 3px 0" type="text" @click="qrshouquan">确认授权</el-button>
                        </div>
                        <div v-for="o in ctkhlist" :key="o.id" class="text item">
                          {{ o.cusname }}
                        </div>
                      </el-card>
                    </el-col>
                  </el-tab-pane>
                  <el-tab-pane label="客户授权" name="khsq"></el-tab-pane>
                </el-tabs>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="产品价格管控" name="cppricegk">
        <el-tabs tab-position="right" v-model="qdpricetab" @tab-click="qbpriceclick">
          <el-tab-pane label="传统渠道" name="ctqd">
            <el-row class="querypanel">
              <el-col :span="8"><div class="queryinput">
                <el-input v-model="query_goodsinfonameex" placeholder="请输入产品名称"></el-input>
              </div></el-col>
              <el-col :span="8"><div class="queryinput">
                <el-select v-model="goodsinfobrandex" filterable placeholder="请选择产品品牌">
                  <el-option
                    v-for="item in goodsinfobrandlist"
                    :key="item.id.Int64"
                    :label="item.name.String"
                    :value="item.id.Int64">
                  </el-option>
                </el-select>
              </div></el-col>
              <el-col :span="8"><div>
                <el-select v-model="goodsinfotypeex" filterable placeholder="请选择产品类别">
                  <el-option
                    v-for="item in goodsinfotypelist"
                    :key="item.id.Int64"
                    :label="item.name.String"
                    :value="item.id.Int64">
                  </el-option>
                </el-select>
              </div></el-col>
              <el-col :span="24" class="querybtn" style="margin-top: 15px">
                <div>
                  <el-button @click="querygoodsinfoex">查找产品</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row class="querypanel">
              <el-col :span="12">
                <el-table
                  fit
                  :data="pricegoodsdata"
                  ref="multipleTable">
                  <el-table-column
                    prop="name"
                    label="产品名称">
                  </el-table-column>

                  <el-table-column
                    label="操作"
                    min-width="50px"
                  >
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="查看产品信息" placement="top-start">
                        <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="lookgoodsspecgroup(scope.$index, pricegoodsdata)"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="12">
                <div class="gispecgroup">
                  <el-card class="box-card">
                    <div slot="header" class="clearfix">
                      <span>规格组列表 ( <span style="font-size: 9px">{{specgroupname}}</span> )</span>
                    </div>
                    <div>
                      <el-table
                        ref="myspecgroup"
                        :data="specgroupdata"
                        fit>
                        <el-table-column
                          type="selection"
                          width="55">
                        </el-table-column>
                        <el-table-column
                          prop="gspecname.String">
                        </el-table-column>
                        <el-table-column
                          min-width="50px"
                        >
                          <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="查看规格属性信息" placement="top-start">
                              <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="lookgoodsspecattr(scope.$index, specgroupdata)"></i>
                            </el-tooltip>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-card>
                  <el-card class="box-card leftpanel">
                    <div slot="header" class="clearfix">
                      <span>产品价格设定</span>
                    </div>
                    <div>
                      <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
                        <el-form-item label="采购定价">
                          <el-input  v-model="buy_price" placeholder="该渠道客户采购价格"></el-input>
                        </el-form-item>
                        <el-form-item label="销售定价">
                          <el-input  v-model="sale_price" placeholder="该渠道客户销售价格"></el-input>
                        </el-form-item>
                        <el-form-item label="市场定价">
                          <el-input  v-model="base_price" placeholder="市场标准销售价格"></el-input>
                        </el-form-item>
                        <el-button @click="savepriceinfo">确定渠道价格</el-button>
                        <el-button @click="savemypriceinfo">保存自方价格</el-button>
                      </el-form>
                    </div>
                  </el-card>
                </div>

              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-card class="box-card leftpanel">
                  <div slot="header" class="clearfix">
                    <span>传统渠道列表</span>
                  </div>
                  <div>
                    <el-tree
                      class="filter-tree"
                      :data="qddata"
                      :props="qdprops"
                      node-key="id"
                      default-expand-all
                      :expand-on-click-node="false"
                      @node-click="gcpriceqdselect">
                    </el-tree>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="box-card leftpanel">
                  <div slot="header" class="clearfix">
                    <span>渠道客户列表</span>
                  </div>
                  <div>
                    <el-table
                      stripe
                      :data="gcqdcusdata"
                      ref="mygcqdcus">
                      <el-table-column
                        type="selection"
                        width="55">
                      </el-table-column>
                      <el-table-column
                        prop="cusname"
                        label="客户名称">
                      </el-table-column>
                      <el-table-column
                        label="操作"
                        width="80px"
                      >
                        <template slot-scope="scope">
                          <el-tooltip class="item" effect="dark" content="选择该渠道客户" placement="top-start">
                            <i class="fa fa-pencil-square-o fa-lg curpointer" v-on:click="selectqdcus(scope.$index, myqdcusdata)"></i>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="规格属性信息" :visible.sync="specattrvisible">
      <div class="tablepanel">
        <el-table
          :data="specattrtb"
          fit>
          <el-table-column
            prop="attrname.String"
            label="属性名"
          >
          </el-table-column>
          <el-table-column
            prop="attrvalue"
            label="属性值"
          >
          </el-table-column>
        </el-table>

      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'GoodsControl',
  data () {
    return {
      qdpricetab: 'ctqd',
      qdinfotab: 'cppricegk',
      goodsinfobrand: '',
      gctabpos: 'top',
      query_goodsinfoname: '',
      query_goodsinfonameex: '',
      goodsinfobrandex: '',
      goodsinfobrandlist: [],
      goodsinfotype: '',
      goodsinfotypeex: '',
      goodsinfotypelist: [],
      goods_rightdata: [],
      goods_leftdata: [],
      qddata: [],
      qdsubtab: 0,
      cusowngoodsdata: [],
      pricegoodsdata: [],
      pricespectbdata: [],
      specgroupdata: [],
      specattrtb: [],
      gcqdcusdata: [],
      specgroupname: '',
      specattrvisible: false,
      ctkhlist: [],
      buy_price: '',
      sale_price: '',
      base_price: '',
      qdprops: {
        children: 'Children',
        label: 'name'
      },
      khid: ''
    }
  },
  mounted: function () {
    that = this
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      var qstr = 'cusid = ' + this.khid
      var qstr1 = 'cusid = ' + this.khid + ' and parentid >0'
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qgt',
        method: 'post',
        data: {
          whereinfo: {String: qstr1, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('*****************初始化分类数据******************')
          if (res.data.success) {
            console.log('已完成分类数据初始化')
            that.goodsinfotypelist = JSON.parse(res.data.data)
            console.log(that.goodsinfotypelist)
          } else {
            console.log('获取分类数据失败')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qgb',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('*****************初始化规格数据******************')
          if (res.data.success) {
            that.goodsinfobrandlist = JSON.parse(res.data.data)
            console.log('已完成品牌数据初始化')
            console.log(that.goodsinfobrandlist)
          } else {
            console.log('获取规格数据失败')
          }
        })

      var ctqdtreetmp = localStorage.getItem('ctqdtree')
      if (ctqdtreetmp === null) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/control/gctree',
          method: 'post',
          data: {
            cusid: {Int64: parseInt(v), Valid: true},
            parentid: {Int64: -1, Valid: true},
            type: {Int64: 0, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.qddata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.qddata = JSON.parse(ctqdtreetmp)
      }
    }
    setTimeout(function () {
      that.$parent.$children[0].$refs.headmenu.activeIndex = getCookie('SelectMainMenuID')
    }, 200)
  },
  methods: {
    querygoodsinfo () {
      var qstr = 'id>0'
      if (this.query_goodsinfoname !== null && this.query_goodsinfoname !== '') {
        qstr = qstr + " and name like '%" + this.query_goodsinfoname + "%' "
      }
      if (this.goodsinfobrand !== null && this.goodsinfobrand !== '') {
        qstr = qstr + ' and brand_id = ' + this.goodsinfobrand
      }
      if (this.goodsinfotype !== null && this.goodsinfotype !== '') {
        qstr = qstr + ' and goods_type_id = ' + this.goodsinfotype
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qginfoex',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.goods_leftdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querygoodsinfoex () {
      var qstr = 'id>0'
      if (this.query_goodsinfonameex !== null && this.query_goodsinfonameex !== '') {
        qstr = qstr + " and name like '%" + this.query_goodsinfonameex + "%' "
      }
      if (this.goodsinfobrandex !== null && this.goodsinfobrandex !== '') {
        qstr = qstr + ' and brand_id = ' + this.goodsinfobrandex
      }
      if (this.goodsinfotypeex !== null && this.goodsinfotypeex !== '') {
        qstr = qstr + ' and goods_type_id = ' + this.goodsinfotypeex
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qginfoex',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.pricegoodsdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gcqdselect (data) {
      console.log(data)
      var idstr = 'cusid = ' + that.khid + ' and c_id=' + parseInt(data.id)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/ccquery',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.ctkhlist = JSON.parse(res.data.data)
            console.log(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    gcpriceqdselect (data) {
      var idstr = 'cusid = ' + that.khid + ' and c_id=' + parseInt(data.id)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/ccquery',
        method: 'post',
        data: {
          whereinfo: {'String': idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.gcqdcusdata = JSON.parse(res.data.data)
            console.log(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    qbsqclick () {},
    qbpriceclick () {},
    qrshouquan () {
      console.log(this.ctkhlist)
      console.log(this.goods_rightdata)
      console.log(this.goods_leftdata)
      var attlist = []
      for (var khindex in this.ctkhlist) {
        var khinfo = this.ctkhlist[khindex]
        for (var index in this.goods_rightdata) {
          var subdata = this.goods_rightdata[index]
          var dataindex = this.goods_leftdata.findIndex(d => d.id === subdata)
          var subdataname = this.goods_leftdata[dataindex]
          console.log(subdata)
          console.log(subdataname)
          var adata
          adata = {
            cuserid: {Int64: parseInt(khinfo.ccusid), Valid: true},
            goodsid: {Int64: subdataname.id, Valid: true},
            cusid: {Int64: parseInt(this.khid), Valid: true}
          }
          attlist.push(adata)
        }
      }
      console.log(attlist)
      that.$http({
        url: 'https://api.sqnetsoft.cn/control/paaucg',
        method: 'post',
        data: attlist,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '已授权'
            })
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seegcgoods (index, data) {},
    upgcgoods (index, data) {},
    delgcgoods (index, data) {},
    lookgoodsspecgroup (index, data) {
      console.log(data[index])
      that.specgroupname = data[index].name
      var qstr2 = 'cusid = ' + that.khid + ' and goodsid=' + parseInt(data[index].id)
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qgsp',
        method: 'post',
        data: {
          whereinfo: {'String': qstr2, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.specgroupdata = JSON.parse(res.data.data)
            that.$message({
              type: 'success',
              message: '已读取规格组信息'
            })
          } else {

          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    seegcpricegoods (index, data) {},
    lookgoodsspecattr (index, data) {
      that.specattrvisible = true
      var qstr = 'cusid = ' + that.khid + ' and specgroupid=' + data[index].id.Int64
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/qgsa',
        method: 'post',
        data: {
          whereinfo: {'String': qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.specattrtb = JSON.parse(res.data.data)
            that.$message({
              type: 'success',
              message: '已读取规格属性'
            })
          } else {

          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savepriceinfo () {
      console.log(this.$refs.myspecgroup)
      console.log(this.$refs.mygcqdcus)
      console.log(this.qd_price)
      if (this.qd_price === '' || this.qd_price === null) {
        that.$message({
          type: 'info',
          message: '价格不允许为空'
        })
      } else {
        var insertdatas = []
        for (var index in this.$refs.myspecgroup.selection) {
          var goodsinfotmp = this.$refs.myspecgroup.selection[index]
          for (var index1 in this.$refs.mygcqdcus.selection) {
            var custmp = this.$refs.mygcqdcus.selection[index1]
            var idata = {
              goodsid: {Int64: parseInt(goodsinfotmp.goodsid), Valid: true},
              specgroupid: {Int64: parseInt(goodsinfotmp.id.Int64), Valid: true},
              cuserid: {Int64: parseInt(custmp.ccusid), Valid: true},
              buyprice: {String: that.buy_price, Valid: true},
              saleprice: {String: that.sale_price, Valid: true},
              baseprice: {String: that.base_price, Valid: true},
              cusid: {Int64: parseInt(that.khid), Valid: true}
            }
            insertdatas.push(idata)
          }
        }
        console.log(insertdatas)
        that.$http({
          url: 'https://api.sqnetsoft.cn/control/paausp',
          method: 'post',
          data: insertdatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已保存价格'
              })
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    savemypriceinfo () {
      if (this.qd_price === '' || this.qd_price === null) {
        that.$message({
          type: 'info',
          message: '价格不允许为空'
        })
      } else {
        var insertdatas = []
        for (var index in this.$refs.myspecgroup.selection) {
          var goodsinfotmp = this.$refs.myspecgroup.selection[index]
          var idata = {
            goodsid: {Int64: parseInt(goodsinfotmp.goodsid), Valid: true},
            specgroupid: {Int64: parseInt(goodsinfotmp.id.Int64), Valid: true},
            cuserid: {Int64: parseInt(that.khid), Valid: true},
            buyprice: {String: that.buy_price, Valid: true},
            saleprice: {String: that.sale_price, Valid: true},
            baseprice: {String: that.base_price, Valid: true},
            cusid: {Int64: parseInt(that.khid), Valid: true}
          }
          insertdatas.push(idata)
        }
        console.log(insertdatas)
        that.$http({
          url: 'https://api.sqnetsoft.cn/control/paausp',
          method: 'post',
          data: insertdatas,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已保存价格'
              })
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/control/GoodsControl.vue